import React, {useState, useEffect, useRef, Fragment} from 'react';
import Hls from 'hls.js';
import {CircularProgress, Stack, useMediaQuery} from "@mui/material";
import {get_camera_stream} from "../../api/routes";

export const Camera = ({cameraId, birdhouseId}) => {
    const videoRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const hlsStreamUrl = get_camera_stream(birdhouseId, cameraId);
    const isMobile = useMediaQuery('(max-width:768px)');

    const loadStream = () => {
        if (!videoRef.current) return;

        if (Hls.isSupported()) {
            const hls = new Hls({
                maxLoadingDelay: 1,
                maxBufferLength: 0,
                maxMaxBufferLength: 1,
                startLevel: 0,
                startPosition: -1,
                maxBufferHole: 0.001,
                highBufferWatchdogPeriod: 0,
                nudgeOffset: 0.05,
                nudgeMaxRetry: 1,
                maxFragLookUpTolerance: .1,
                liveSyncDurationCount: 1,
                abrEwmaFastLive: 1,
                abrEwmaSlowLive: 3,
                abrEwmaFastVoD: 1,
                abrEwmaSlowVoD: 3,
                maxStarvationDelay: 1,
            });
            hls.loadSource(hlsStreamUrl);
            hls.attachMedia(videoRef.current);

            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                setLoading(false);
            });

            return hls;
        } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
            videoRef.current.src = hlsStreamUrl;
            videoRef.current.addEventListener('loadedmetadata', () => {
                setLoading(false);
            });
        }
    };

    useEffect(() => {
        loadStream();
    }, [hlsStreamUrl, videoRef.current]);

    const [dimensions, setDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    useEffect(() => {
        const handleResize = () => {
            setDimensions({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const videoHeight = loading ? '0px' : (isMobile ? `100%` : '60%');
    const videoWidth = isMobile ? '100%' : `calc(${(dimensions.width * 0.3) * (16 / 9)}px - 100px)`;

    return (
        <Fragment>
            {loading && (
                <Stack alignItems="center" justifyContent="center" width="100%">
                    <CircularProgress color="primary" />
                </Stack>
            )}
            <Stack height={videoHeight} width={videoWidth} overflow="hidden">
                <video
                    ref={videoRef}
                    style={{ borderRadius: '15px', overflow: 'hidden' }}
                    playsInline
                    autoPlay
                    muted
                />
            </Stack>
        </Fragment>
    );
};
